export default {
  en: {
    firstNameLabel: 'First Name',
    surnameLabel: 'Last Name',
    emailLabel: 'Email Address',
    phoneLabel: 'Phone Number',
    companyLabel: 'Company Name',
    jobTitleLabel: 'Job Title',
    countryLabel: 'Country',
    countryPlaceholder: 'Select country...',
    zipLabel: 'ZIP/Postal Code',
    commentsLabel: 'Comment',
    submitLabel: 'Submit',
  },
  es: {
    firstNameLabel: 'Nombre',
    surnameLabel: 'Apellido',
    emailLabel: 'Dirección de correo electrónico',
    phoneLabel: 'Teléfono',
    companyLabel: 'Nombre de la compañía',
    jobTitleLabel: 'Cargo/Posición',
    countryLabel: 'País',
    countryPlaceholder: 'Seleccione el país...',
    zipLabel: 'Código postal',
    commentsLabel: 'Comentarios',
    submitLabel: 'Enviar',
  },
  pt: {
    firstNameLabel: 'Nome',
    surnameLabel: 'Sobrenome',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
    companyLabel: 'Nome da empresa',
    jobTitleLabel: 'Cargo',
    countryLabel: 'País',
    countryPlaceholder: 'Selecione o país...',
    zipLabel: 'CEP',
    commentsLabel: 'Comentário',
    submitLabel: 'Enviar',
  },
};
